import deleteWithSwal from '@/common/deleteWithSwal'
import setupActionCable from './actionCable'
import showFlashes from './flashes'

function initOnce() {
  deleteWithSwal()
  setupActionCable()
  showFlashes()
}

if (document.readyState !== 'loading') {
  initOnce()
} else {
  document.addEventListener('DOMContentLoaded', initOnce)
}
